import { Store } from '@ngrx/store';
import type { MyVerbale as MyVerbale53 } from '../../features/revisione53/core/models/interfaces/revisione.interface';
import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { asyncScheduler, mergeMap, Observable, observeOn, of, timeoutWith } from 'rxjs';
import { distinctUntilChanged, filter, map, skip, switchMap, take } from 'rxjs/operators';
import { isEqual } from 'lodash-es';
import { Revisione53CoreActions } from '../../features/revisione53/core/store/revisione53.actions';
import { Revisione53CoreSelectors } from '../../features/revisione53/core/store/selectors/core.selectors';

export function createStoreValidator(store: Store, callback: (myVerbale: MyVerbale53, control?: AbstractControl) => any, options?: { maxWaitMs?: number }): AsyncValidatorFn {
    return (control: AbstractControl): Observable<any> => {
        const maxWaitMs = options?.maxWaitMs ?? 250;
        const select$ = store.select(Revisione53CoreSelectors.getMyVerbale).pipe(filter((v): v is MyVerbale53 => !!v));

        const current$ = select$.pipe(take(1));
        const next$ = select$.pipe(skip(1), take(1));
        return current$.pipe(
            switchMap((current) => next$.pipe(timeoutWith(maxWaitMs, of(current)))),
            observeOn(asyncScheduler),
            map((myVerbale) => callback(myVerbale, control))
        );
    };
}

export function updateVerbaleOnStore(store: Store, callback: (myVerbale: MyVerbale53) => MyVerbale53): void {
    store.dispatch(Revisione53CoreActions.updateMyVerbaleFromListener({ callback }));
}

export function createWarning(store: Store, callback: (myVerbale: MyVerbale53) => string | string[]): Observable<string[]> {
    return store.select(Revisione53CoreSelectors.getMyVerbale).pipe(
        map(callback),
        map((warning) => (typeof warning === 'string' ? [warning] : warning)),
        distinctUntilChanged(isEqual)
    );
}

export function createAsyncWarning(store: Store, callback: (myVerbale: MyVerbale53) => Observable<string | string[]>): Observable<string[]> {
    return store.select(Revisione53CoreSelectors.getMyVerbale).pipe(
        mergeMap(callback),
        map((warning) => (typeof warning === 'string' ? [warning] : warning)),
        distinctUntilChanged(isEqual)
    );
}
